import { Dispatch } from "redux";
import {QuickbetAction, QuickbetActionTypes} from "../../types/Quickbet/quickbetTypes";
import axios from "axios";

interface ErrorResponse {
    code: number;
    message: string;
}

export const getQuickbetData = (id: string): any => {
    return async (dispatch: Dispatch<QuickbetAction>) => {
        try {
            dispatch({ type: QuickbetActionTypes.FETCH_QUICKBET_DATA });
            const response = await axios({
                method: 'get',
                url: `/api/quickbet_cards/${id}`,
                withCredentials: false
            });

            dispatch({ type: QuickbetActionTypes.FETCH_QUICKBET_DATA_SUCCESS, payload: response.data });
        } catch (error: any) {
            let errorPayload: ErrorResponse;
            if (error.response && error.response.data) {
                const { code, message } = error.response.data;
                errorPayload = { code, message };
            } else {
                errorPayload = { code: -1, message: 'Unknown error occurred' };
            }
            dispatch({ type: QuickbetActionTypes.FETCH_QUICKBET_DATA_ERROR, payload: errorPayload });
        }
    }
}
